document.addEventListener('DOMContentLoaded', function() {
  let _cartDrawer = document.getElementById('cart-drawer');

  const selectors$E = {
    outerSection: '[data-section-id]',
    aos: '[data-aos]',
    additionalCheckoutButtons: '[data-additional-checkout-button]',
    apiContent: '[data-api-content]',
    apiLineItems: '[data-api-line-items]',
    apiUpsellItems: '[data-api-upsell-items]',
    apiCartPrice: '[data-api-cart-price]',
    buttonAddToCart: 'button[name="add"]',
    upsellButtonByHandle: '[data-handle]',
    cartCloseError: '[data-cart-error-close]',
    cartDrawer: '[data-cart-drawer]',
    cartDrawerTemplate: '[data-cart-drawer-template]',
    cartDrawerToggle: '[data-cart-drawer-toggle]',
    cartDrawerBody: '[data-cart-drawer-body]',
    cartErrors: '[data-cart-errors]',
    cartForm: '[data-cart-form]',
    cartTermsCheckbox: '[data-cart-acceptance-checkbox]',
    cartCheckoutButtonWrapper: '[data-cart-checkout-buttons]',
    cartCheckoutButton: '[data-cart-checkout-button]',
    cartItemRemove: '[data-item-remove]',
    cartItemsQty: '[data-cart-items-qty]',
    cartTotal: '[data-cart-total]',
    cartTotalPrice: '[data-cart-total-price]',
    cartMessage: '[data-cart-message]',
    cartMessageDefault: '[data-message-default]',
    cartPage: '[data-cart-page]',
    cartProgress: '[data-cart-message-progress]',
    emptyMessage: '[data-empty-message]',
    buttonHolder: '[data-foot-holder]',
    item: '[data-cart-item]',
    itemsHolder: '[data-items-holder]',
    itemsWrapper: '[data-items-wrapper]',
    formCloseError: '[data-close-error]',
    formErrorsContainer: '[data-cart-errors-container]',
    upsellHolder: '[data-upsell-holder]',
    errorMessage: '[data-error-message]',
    termsErrorMessage: '[data-terms-error-message]',
    pairProductsHolder: '[data-pair-products-holder]',
    pairProducts: '[data-pair-products]',
    priceHolder: '[data-cart-price-holder]',
    leftToSpend: '[data-left-to-spend]',
    quickBuyForm: '[data-quickbuy-form]',
    qtyInput: '[data-quantity-field]',
    productMediaContainer: '[data-product-media-container]',
    formWrapper: '[data-form-wrapper]',
    productForm: '[data-product-form]',
    popupQuickView: '.popup-quick-view',
    popupClose: '[data-popup-close]',
    error: '[data-error]',
    quickViewOnboarding: '[data-quick-view-onboarding]',
    flickityEnabled: '.flickity-enabled'
  };

  const a11y = {


    /**
     * A11y Helpers
     * -----------------------------------------------------------------------------
     * A collection of useful functions that help make your theme more accessible
     */

    state: {
      firstFocusable: null,
      lastFocusable: null,
      trigger: null
    },

    trapFocus: function(options) {
      var focusableElements = Array.from(options.container.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex^="-"])')).filter(function(element) {
        var width = element.offsetWidth;
        var height = element.offsetHeight;

        return width !== 0 && height !== 0 && getComputedStyle(element).getPropertyValue('display') !== 'none';
      });

      focusableElements = focusableElements.filter(function(element) {
        return ! element.classList.contains('deferred-media__poster');
      });

      this.state.firstFocusable = focusableElements[0];
      this.state.lastFocusable = focusableElements[focusableElements.length - 1];

      if (! options.elementToFocus) {
        options.elementToFocus = this.state.firstFocusable || options.container;
      }
      this._setupHandlers();

      document.addEventListener('focusin', this._onFocusInHandler);
      document.addEventListener('focusout', this._onFocusOutHandler);

      options.container.setAttribute('tabindex', '-1');
      options.elementToFocus.focus();
    },

    removeTrapFocus: function(options) {
      const focusVisible = !document.body.classList.contains('no-outline');
      if (options && options.container) {
        options.container.removeAttribute('tabindex');
      }
      document.removeEventListener('focusin', this._onFocusInHandler);

      if (this.state.trigger && focusVisible) {
        this.state.trigger.focus();
      }
    },

    _manageFocus: function(evt) {
      if (evt.code !== 9) {
        return;
      }


/**
         * On the last focusable element and tab forward,
         * focus the first element.
         */
      if (evt.target === this.state.lastFocusable && ! evt.shiftKey) {
        evt.preventDefault();
        this.state.firstFocusable.focus();
      }


/**
         * On the first focusable element and tab backward,
         * focus the last element.
         */
      if (evt.target === this.state.firstFocusable && evt.shiftKey) {
        evt.preventDefault();
        this.state.lastFocusable.focus();
      }
    },

    _onFocusOut: function() {
      document.removeEventListener('keydown', this._manageFocusHandler);
    },

    _onFocusIn: function(evt) {
      if (evt.target !== this.state.lastFocusable && evt.target !== this.state.firstFocusable) {
        return;
      }

      document.addEventListener('keydown', this._manageFocusHandler);
    },

    _setupHandlers: function() {
      if (!this._onFocusInHandler) {
        this._onFocusInHandler = this._onFocusIn.bind(this);
      }

      if (!this._onFocusOutHandler) {
        this._onFocusOutHandler = this._onFocusIn.bind(this);
      }

      if (!this._manageFocusHandler) {
        this._manageFocusHandler = this._manageFocus.bind(this);
      }
    }
  };

  const throttle = (fn, wait) => {
    let prev,
      next;
    return function invokeFn(...args) {
      const now = Date.now();
      next = clearTimeout(next);
      if (! prev || now - prev >= wait) { // eslint-disable-next-line prefer-spread
        fn.apply(null, args);
        prev = now;
      } else {
        next = setTimeout(invokeFn.bind(null, ...args), wait -(now - prev));
      }
    };
  };

  const settings$1 = {
    cartDrawerEnabled: true,
    timers: {
      addProductTimeout: 1000
    },
    animations: {
      data: 'data-aos',
      method: 'fade-up'
    }
  };

  const attributes$p = {
    shippingMessageLimit: 'data-limit',
    cartMessageValue: 'data-cart-message',
    cartTotal: 'data-cart-total',
    ariaExpanded: 'aria-expanded',
    disabled: 'disabled',
    value: 'value',
    dataId: 'data-id',
    item: 'data-item',
    itemIndex: 'data-item-index',
    itemTitle: 'data-item-title',
    atcTrigger: 'data-atc-trigger',
    upsellButton: 'data-upsell-btn',
    notificationPopup: 'data-notification-popup',
    sectionId: 'data-section-id',
    recipientError: 'data-recipient-errors'
  };

  const selectors$10 = {
    quantityHolder: '[data-quantity-holder]',
    quantityField: '[data-quantity-field]',
    quantityButton: '[data-quantity-button]',
    quantityMinusButton: '[data-quantity-minus]',
    quantityPlusButton: '[data-quantity-plus]'
  };

  const selectors$11 = {
    single: '[data-collapsible-single]', // Add this attribute when we want only one item expanded at the same time
    trigger: '[data-collapsible-trigger]',
    content: '[data-collapsible-content]'
  };

  const classes$Q = {
    isExpanded: 'is-expanded'
  };

  const attributes$G = {
    expanded: 'aria-expanded',
    controls: 'aria-controls',
    triggerMobile: 'data-collapsible-trigger-mobile',
    transitionOverride: 'data-collapsible-transition-override'
  };

  const settings$6 = {
    animationDelay: 500
  };

  const settings$2 = {
    templateIndex: 0
  };

  const selectors$F = {
    buttonQuickView: '[data-button-quick-view]',
    quickViewItemsTemplate: '[data-quick-view-items-template]',
    cartDrawer: '[data-cart-drawer]',
    shopTheLookQuickViewButton: '[data-shop-the-look-quick-view-button]',
    shopTheLookThumb: '[data-shop-the-look-thumb]',
    quickViewItemHolder: '[data-quick-view-item-holder]'
  };

  const classes$v = {
    loading: 'is-loading',
    isActive: 'is-active',
    quickViewFromCart: 'js-quick-view-from-cart',
    mainClass: 'popup-quick-view pswp--not-close-btn',
    shopTheLookPopupClass: 'popup-quick-view popup-quick-view--shop-the-look pswp--not-close-btn'
  };

  const attributes$q = {
    loaded: 'data-loaded',
    handle: 'data-handle',
    variantId: 'data-variant-id',
    shopTheLookQuickView: 'data-shop-the-look-quick-view',
    hotspot: 'data-hotspot',
    quickButtonInit: 'data-initialized'
  };

  const options = {
    history: false,
    focus: false,
    mainClass: classes$v.mainClass,
    showHideOpacity: false, // we need that off to control the animation ourselves
    closeOnVerticalDrag: false,
    closeOnScroll: false,
    modal: false,
    escKey: false
  };

  const classes$P = {
    quantityReadOnly: 'read-only',
    isDisabled: 'is-disabled'
  };

  const classes$u = {
    hidden: 'hidden',
    added: 'is-added',
    isHidden: 'is-hidden',
    cartDrawerOpen: 'js-drawer-open-cart',
    open: 'is-open',
    visible: 'is-visible',
    expanded: 'is-expanded',
    loading: 'is-loading',
    disabled: 'is-disabled',
    success: 'is-success',
    error: 'has-error',
    cartItems: 'cart__toggle--has-items',
    variantSoldOut: 'variant--soldout',
    removed: 'is-removed',
    aosAnimate: 'aos-animate',
    updated: 'is-updated',
    noOutline: 'no-outline',
    productGridImageError: 'product-grid-item__image--error',
    contentVisibilityHidden: 'cv-h'
  };

  const classes$U = {
    quickViewVisible: 'js-quick-view-visible',
    cartDrawerOpen: 'js-drawer-open-cart'
  };

  let scrollLockTimer$1 = 0;

  function lock(e) {

// Prevent body scroll lock race conditions
    setTimeout(() => {
      if (scrollLockTimer$1) {
        clearTimeout(scrollLockTimer$1);
      }


      scrollLock.disablePageScroll(e.detail, {
        allowTouchMove: (el) => el.tagName === 'TEXTAREA'
      });

      document.documentElement.setAttribute('data-scroll-locked', '');
    });
  }

  function unlock(e) {
    const timeout = e.detail;

    if (timeout) {
      scrollLockTimer$1 = setTimeout(removeScrollLock, timeout);
    } else {
      removeScrollLock();
    }
  }

  function removeScrollLock() {
    const isPopupVisible = document.body.classList.contains(classes$U.quickViewVisible) || document.body.classList.contains(classes$U.cartDrawerOpen);

    if (! isPopupVisible) {
      scrollLock.clearQueueScrollLocks();
      scrollLock.enablePageScroll();
      document.documentElement.removeAttribute('data-scroll-locked');
    }
  }

  class CartDrawer {
    constructor() {
      if (window.location.pathname === '/password') {
        return;
      }

      this.init();
    }

    init() {

// DOM Elements
      this.cartToggleButtons = document.querySelectorAll(selectors$E.cartDrawerToggle);
      this.cartPage = document.querySelector(selectors$E.cartPage);
      this.cartDrawer = document.querySelector(selectors$E.cartDrawer);
      this.cart = this.cartDrawer || this.cartPage;

      this.cartCount = this.getCartItemCount();

      this.assignArguments();

      this.recipientErrors = this.form ?. getAttribute(attributes$p.recipientError) === 'true';
      this.flktyUpsell = null;
      this.form = null;
      this.collapsible = null;
      this.a11y = a11y;

      this.build = this.build.bind(this);

// AJAX request
      this.addToCart = this.addToCart.bind(this);
      this.updateCart = this.updateCart.bind(this);

// Cart events
      this.openCartDrawer = this.openCartDrawer.bind(this);
      this.closeCartDrawer = this.closeCartDrawer.bind(this);
      this.toggleCartDrawer = this.toggleCartDrawer.bind(this);
      this.formSubmitHandler = throttle(this.formSubmitHandler.bind(this), 50);
      this.closeCartError = () => {
        this.cartErrorHolder.classList.remove(classes$u.expanded);
      };
      this.cartDrawerCloseEvent = null;

// Checking
      this.hasItemsInCart = this.hasItemsInCart.bind(this);
      this.isCartPage = Boolean(this.cart && this.cartDrawer === null);
      this.showAnimations = Boolean(document.body.dataset.animations === 'true');

// Set classes
      this.toggleClassesOnContainers = this.toggleClassesOnContainers.bind(this);

// Flags
      this.totalItems = 0;
      this.isCartDrawerOpen = false;
      this.isCartDrawerLoaded = false;
      this.cartDiscounts = 0;
      this.cartDrawerEnabled = settings$1.cartDrawerEnabled;
      this.cartAnimationTimer = 0;
      this.cartUpdateFailed = false;

// Cart Events
      this.cartEvents();
      this.cartAddEvent();
      this.cartDrawerToggleEvents();

// Init quantity for fields
      this.initQuantity();

// Init collapsible function for the cart accordions
      if (this.buttonHolder) {
        this.collapsible = new Collapsible(this.buttonHolder);
      }

      if (this.isCartPage) {
        this.renderPairProducts();
      }

      document.addEventListener('theme:popup:open', this.closeCartDrawer);
      document.addEventListener('theme:cart:add', () => {});
      document.addEventListener('theme:cart:added', (event) => {
        //console.log("theme:cart:added => ",  this, this.cartCount);
       this.updateCartCount(this.cartCount);
      });
    }


/**
     * Assign cart constructor arguments on page load or after cart drawer is loaded
     *
     * @return  {Void}
     */
    assignArguments() {
      this.cartDrawerBody = document.querySelector(selectors$E.cartDrawerBody);
      this.emptyMessage = document.querySelector(selectors$E.emptyMessage);
      this.buttonHolder = document.querySelector(selectors$E.buttonHolder);
      this.itemsHolder = document.querySelector(selectors$E.itemsHolder);
      this.cartItemsQty = document.querySelector(selectors$E.cartItemsQty);
      this.itemsWrapper = document.querySelector(selectors$E.itemsWrapper);
      this.items = document.querySelectorAll(selectors$E.item);
      this.cartTotal = document.querySelector(selectors$E.cartTotal);
      this.cartTotalPrice = document.querySelector(selectors$E.cartTotalPrice);
      this.cartMessage = document.querySelectorAll(selectors$E.cartMessage);
      this.cartOriginalTotal = document.querySelector(selectors$E.cartOriginalTotal);
      this.cartErrorHolder = document.querySelector(selectors$E.cartErrors);
      this.cartCloseErrorMessage = document.querySelector(selectors$E.cartCloseError);
      this.pairProductsHolder = document.querySelector(selectors$E.pairProductsHolder);
      this.pairProducts = document.querySelector(selectors$E.pairProducts);
      this.priceHolder = document.querySelector(selectors$E.priceHolder);
      this.upsellHolders = document.querySelectorAll(selectors$E.upsellHolder);
      this.cartTermsCheckbox = document.querySelector(selectors$E.cartTermsCheckbox);
      this.cartCheckoutButtonWrapper = document.querySelector(selectors$E.cartCheckoutButtonWrapper);
      this.cartCheckoutButton = document.querySelector(selectors$E.cartCheckoutButton);
      this.cartForm = document.querySelector(selectors$E.cartForm);
      this.cartItemCount = 0;
      this.subtotal = window.theme.subtotal;
      this.button = null;

      if (this.cartMessage.length > 0) {
        this.cartFreeLimitShipping = Number(this.cartMessage[0].getAttribute(attributes$p.shippingMessageLimit)) * 100 * window.Shopify.currency.rate;
      }
      this.updateProgress();
    }

    updateCartCount(newCount) {
      var cartCountDiv = document.getElementById('cartCount');
      var cartLinkSpan = document.querySelector('#cartLink .text-link');

      cartCountDiv.innerText = newCount;
      cartLinkSpan.innerText = `Cart (${newCount})`;
    }


/**
     * Init quantity field functionality
     *
     * @return  {Void}
     */

    initQuantity() {
      this.items = document.querySelectorAll(selectors$E.item);

      this.items ?. forEach((item) => {
        const quantity = new QuantityCounter(item, true);

        quantity.init();
        this.cartUpdateEvent(item);
      });
    }


/**
     * Custom event who change the cart
     *
     * @return  {Void}
     */

    cartUpdateEvent(item) {
      item.addEventListener('theme:cart:update', (event) => {
        this.updateCart({id: event.detail.id, quantity: event.detail.quantity}, item);
      });
    }


/**
     * Cart events
     *
     * @return  {Void}
     */

    cartEvents() {
      const cartItemRemove = document.querySelectorAll(selectors$E.cartItemRemove);
      this.totalItems = cartItemRemove.length;

      cartItemRemove ?. forEach((button) => {
        const item = button.closest(selectors$E.item);
        button.addEventListener('click', (event) => {
          event.preventDefault();

          if (button.classList.contains(classes$u.disabled)) return;
          
          document.dispatchEvent(new CustomEvent('theme:cart:update'));
          this.updateCart({
            id: item.getAttribute(attributes$p.dataId),
            quantity: 0
          }, item);
        });
      });

      if (this.cartCloseErrorMessage) {
        this.cartCloseErrorMessage.removeEventListener('click', this.closeCartError);
        this.cartCloseErrorMessage.addEventListener('click', this.closeCartError);
      }

      if (this.cartTermsCheckbox) {
        this.cartTermsCheckbox.removeEventListener('change', this.formSubmitHandler);
        this.cartCheckoutButtonWrapper.removeEventListener('click', this.formSubmitHandler);
        this.cartForm.removeEventListener('submit', this.formSubmitHandler);

        this.cartTermsCheckbox.addEventListener('change', this.formSubmitHandler);
        this.cartCheckoutButtonWrapper.addEventListener('click', this.formSubmitHandler);
        this.cartForm.addEventListener('submit', this.formSubmitHandler);
      }
    }


/**
     * Cart event add product to cart
     *
     * @return  {Void}
     */

    cartAddEvent() {
      document.addEventListener('click', (event) => {
        const clickedElement = event.target;
        const isButtonATC = clickedElement ?. matches(selectors$E.buttonAddToCart);
        const getButtonATC = clickedElement ?. closest(selectors$E.buttonAddToCart);

        if (isButtonATC || getButtonATC) {
          event.preventDefault();

          this.button = isButtonATC
            ? clickedElement
            : getButtonATC;
          this.form = clickedElement.closest('form');
          this.recipientErrors = this.form ?. getAttribute(attributes$p.recipientError) === 'true';
          this.formWrapper = this.button.closest(selectors$E.formWrapper);
          const isVariantSoldOut = this.formWrapper ?. classList.contains(classes$u.variantSoldOut);
          const isButtonDisabled = this.button.hasAttribute(attributes$p.disabled);
          const isQuickViewOnboarding = this.button.closest(selectors$E.quickViewOnboarding);
          const hasDataAtcTrigger = this.button.hasAttribute(attributes$p.atcTrigger);
          const hasNotificationPopup = this.button.hasAttribute(attributes$p.notificationPopup);
          const hasFileInput = this.form ?. querySelector('[type="file"]');

          if (isButtonDisabled || hasFileInput || isQuickViewOnboarding) return;
          

// Notification popup
          if (isVariantSoldOut && hasNotificationPopup) {
            new NotificationPopup(this.button);
            return;
          }

          if (hasDataAtcTrigger) {
            this.a11y.state.trigger = this.button;
          }

          const formData = new FormData(this.form);
          this.addToCart(formData);

// Hook for cart/add.js event
          document.dispatchEvent(new CustomEvent('theme:cart:add', {
            bubbles: true,
            detail: {
              selector: clickedElement
            }
          }));
        }
      });
    }


/**
     * Get response from the cart
     *
     * @return  {Void}
     */

    getCart() {

// Render cart drawer if it exists but it's not loaded yet
      if (this.cartDrawer && !this.isCartDrawerLoaded) {
        const alwaysOpen = false;
        this.renderCartDrawer(alwaysOpen);
      }

      fetch(theme.routes.cart_url + '?section_id=api-cart-items')
        .then(this.handleErrors)
        .then((response) => response.text())
        .then((response) => {
          const element = document.createElement('div');
          element.innerHTML = response;

          const cleanResponse = element.querySelector(selectors$E.apiContent);
          this.build(cleanResponse);
        })
        .catch((error) => console.log(error));
    }


/**
     * Add item(s) to the cart and show the added item(s)
     *
     * @param   {String}  data
     * @param   {DOM Element}  button
     *
     * @return  {Void}
     */

    addToCart(data) {
      if (this.cartDrawerEnabled && this.button) {
        this.button.classList.add(classes$u.loading);
        this.button.setAttribute(attributes$p.disabled, true);
      }

      fetch(theme.routes.cart_add_url, {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          Accept: 'application/javascript'
        },
        body: data
      }).then((response) => response.json()).then((response) => {
        this.button.disabled = true;
        this.addLoadingClass();

        if (response.status) {
          this.addToCartError(response);
          this.removeLoadingClass();
          return;
        }

        this.hideAddToCartErrorMessage();

        if (this.cartDrawerEnabled) {
          this.getCart();
        } else {
          window.location = theme.routes.cart_url;
        }
      }).catch((error) => console.log(error));
    }


/**
     * Update cart
     *
     * @param   {Object}  updateData
     *
     * @return  {Void}
     */

    updateCart(updateData = {}, currentItem = null) {
      let updatedQuantity = updateData.quantity;
      if (currentItem !== null) {
        if (updatedQuantity) {
          currentItem.classList.add(classes$u.loading);
        } else {
          currentItem.classList.add(classes$u.removed);
        }
      }
      this.disableCartButtons();
      this.addLoadingClass();

      const newItem = this.cart.querySelector(`[${
        attributes$p.item
      }="${
        updateData.id
      }"]`) || currentItem;
      const lineIndex = newItem ?. hasAttribute(attributes$p.itemIndex)
        ? parseInt(newItem.getAttribute(attributes$p.itemIndex))
        : 0;
      const itemTitle = newItem ?. hasAttribute(attributes$p.itemTitle)
        ? newItem.getAttribute(attributes$p.itemTitle)
        : null;

      if (lineIndex === 0) return;
      

      const data = {
        line: lineIndex,
        quantity: updatedQuantity
      };

      fetch(theme.routes.cart_change_url, {
        method: 'post',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify(data)
      }).then((response) => {
        if (response.status === 400) {
          const error = new Error(response.status);
          this.cartDrawerEnabled
            ? this.getCart()
            : (window.location = theme.routes.cart_url);
          throw error;
        }
        return response.text();
      }).then((state) => {
        const parsedState = JSON.parse(state);

        if (parsedState.errors) {
          this.cartUpdateFailed = true;
          this.updateErrorText(itemTitle);
          this.toggleErrorMessage();
          this.resetLineItem(currentItem);
          this.enableCartButtons();
          this.removeLoadingClass();

          return;
        }

        this.getCart();
      }).catch((error) => {
        console.log(error);
        this.enableCartButtons();
        this.removeLoadingClass();
      });
    }


/**
     * Reset line item initial state
     *
     * @return  {Void}
     */
    resetLineItem(item) {
      const qtyInput = item.querySelector(selectors$E.qtyInput);
      const qty = qtyInput.getAttribute('value');
      qtyInput.value = qty;
      item.classList.remove(classes$u.loading);
    }


/**
     * Disable cart buttons and inputs
     *
     * @return  {Void}
     */
    disableCartButtons() {
      const inputs = this.cart.querySelectorAll('input');
      const buttons = this.cart.querySelectorAll(`button, ${
        selectors$E.cartItemRemove
      }`);

      if (inputs.length) {
        inputs.forEach((item) => {
          item.classList.add(classes$u.disabled);
          item.blur();
          item.disabled = true;
        });
      }

      if (buttons.length) {
        buttons.forEach((item) => {
          item.setAttribute(attributes$p.disabled, true);
        });
      }
    }


/**
     * Enable cart buttons and inputs
     *
     * @return  {Void}
     */
    enableCartButtons() {
      const inputs = this.cart.querySelectorAll('input');
      const buttons = this.cart.querySelectorAll(`button, ${
        selectors$E.cartItemRemove
      }`);

      if (inputs.length) {
        inputs.forEach((item) => {
          item.classList.remove(classes$u.disabled);
          item.disabled = false;
        });
      }

      if (buttons.length) {
        buttons.forEach((item) => {
          item.removeAttribute(attributes$p.disabled);
        });
      }
    }


/**
     * Update error text
     *
     * @param   {String}  itemTitle
     *
     * @return  {Void}
     */

    updateErrorText(itemTitle) {
      this.cartErrorHolder.querySelector(selectors$E.errorMessage).innerText = itemTitle;
    }


/**
     * Toggle error message
     *
     * @return  {Void}
     */

    toggleErrorMessage() {
      if (!this.cartErrorHolder) return;
      

      this.cartErrorHolder.classList.toggle(classes$u.expanded, this.cartUpdateFailed);

      if (this.cartUpdateFailed) {
        const cartCloseError = this.cartErrorHolder.querySelector(selectors$E.cartCloseError);
        this.focusOnErrorMessage(this.cartErrorHolder, cartCloseError);
      }

// Reset cart error events flag
      this.cartUpdateFailed = false;
    }


/**
     * Handle errors
     *
     * @param   {Object}  response
     *
     * @return  {Object}
     */

    handleErrors(response) {
      if (!response.ok) {
        return response.json().then(function(json) {
          const e = new FetchError({status: response.statusText, headers: response.headers, json: json});
          throw e;
        });
      }
      return response;
    }


/**
     * Add to cart error handle
     *
     * @param   {Object}  data
     * @param   {DOM Element/Null} button
     *
     * @return  {Void}
     */

    addToCartError(data) {
      const buttonQuickBuyForm = this.button.closest(selectors$E.quickBuyForm);
      const buttonUpsellHolder = this.button.closest(selectors$E.upsellHolder);
      const isFocusEnabled = !document.body.classList.contains(classes$u.noOutline);

// holder: Product form containers or Upsell products in Cart form
      let holder = this.button.closest(selectors$E.productForm)
        ? this.button.closest(selectors$E.productForm)
        : this.button.closest(selectors$E.upsellHolder);
      let errorContainer = holder.querySelector(selectors$E.formErrorsContainer);

// Upsell products in Cart form
      if (buttonUpsellHolder) {
        errorContainer = buttonUpsellHolder.querySelector(selectors$E.formErrorsContainer);
      }

      if (this.cartDrawerEnabled && this.button && this.button.closest(selectors$E.cartDrawer) !== null && !this.button.closest(selectors$E.cartDrawer)) {
        this.closeCartDrawer();
      }

      this.button.classList.remove(classes$u.loading);
      this.button.removeAttribute(attributes$p.disabled);

// Error message content
      const closeErrorButton = buttonQuickBuyForm
        ? ''
        : `
      <button type="button" class="errors__button-close" data-close-error>
        ${
          theme.icons.close
        }
      </button>
    `;

      let errorMessages = `${
        data.message
      }: ${
        data.description
      }`;
      if (this.recipientErrors && data.description && typeof data.description === 'object') {
        errorMessages = Object.entries(data.description).map(([key, value]) => `${value}`).join('<br>');
      }

      errorContainer.innerHTML = `
      <div class="errors" data-error autofocus>
        ${errorMessages}
        ${closeErrorButton}
      </div>
    `;

// Quick buy in PGI errors
      if (buttonQuickBuyForm) {
        const productMediaContainer = errorContainer.closest(selectors$E.productMediaContainer);
        productMediaContainer.classList.add(classes$u.productGridImageError);

        errorContainer.querySelector(selectors$E.error).addEventListener('animationend', () => {
          productMediaContainer.classList.remove(classes$u.productGridImageError);
          errorContainer.innerHTML = '';

          if (! isFocusEnabled) {
            document.activeElement.blur();
          }
        });
      } else { // PDP form, Quick view popup forms and Upsell sliders errors
        errorContainer.classList.add(classes$u.visible);
        errorContainer.addEventListener('transitionend', () => {
          this.resizeSliders(errorContainer);
        });

        this.handleCloseErrorMessages(errorContainer);
      }
    }


/**
     * Handle close buttons in error messages containers
     *
     * @param   {Object}  The error container that holds the close button
     * @return  {Void}
     */
    handleCloseErrorMessages(container) {
      const formErrorClose = container.querySelector(selectors$E.formCloseError);

      formErrorClose ?. addEventListener('click', (event) => {
        const clickedElement = event.target;
        const isFormCloseError = clickedElement.matches(selectors$E.formCloseError) || clickedElement.closest(selectors$E.formCloseError);

        if (! isFormCloseError) return;
        

        event.preventDefault();
        container.classList.remove(classes$u.visible);
        container.querySelector(selectors$E.error).addEventListener('transitionend', () => {
          container.innerHTML = '';
          this.resizeSliders(clickedElement);
        });
      });

      this.focusOnErrorMessage(container, formErrorClose);
    }


/**
     * Focus on the error container's close button so that the alert message is read outloud on voiceover assistive technologies
     *
     * @param   {Object}  The error container that holds the error message
     * @param   {Object}  The button that closes the error message
     * @return  {Void}
     */
    focusOnErrorMessage(container, button) {
      const isFocusEnabled = !document.body.classList.contains(classes$u.noOutline);

      if (! isFocusEnabled) return;
      

      container.addEventListener('transitionend', () => {
        requestAnimationFrame(() => button ?. focus({focusVisible: true}));
      });
    }


/**
     * Hide error message container as soon as an item is successfully added to the cart
     */
    hideAddToCartErrorMessage() {
      const holder = this.button.closest(selectors$E.upsellHolder)
        ? this.button.closest(selectors$E.upsellHolder)
        : this.button.closest(selectors$E.productForm);
      const errorContainer = holder ?. querySelector(selectors$E.formErrorsContainer);
      errorContainer ?. classList.remove(classes$u.visible);
    }


/**
     * Resize sliders height
     *
     * @param   {Object}  Element within the slider container that would be resized
     * @return  {Void}
     */
    resizeSliders(element) {
      const slider = element.closest(selectors$E.flickityEnabled);

      if (! slider) return;
      

      const flkty = Flickity.data(slider);
      requestAnimationFrame(() => flkty.resize());
    }


/**
     * Render cart and define all elements after cart drawer is open for a first time
     *
     * @return  {Void}
     */
    renderCartDrawer(alwaysOpen = true) {
      const cartDrawerTemplate = document.querySelector(selectors$E.cartDrawerTemplate);

      if (! cartDrawerTemplate) {
        return;
      }

// Append cart items HTML to the cart drawer container
      this.cartDrawer.innerHTML = cartDrawerTemplate.innerHTML;
      this.assignArguments();

// Bind cart quantity events
      this.initQuantity();

// Bind cart events
      this.cartEvents();

// Init collapsible function for the cart drawer accordions
      if (this.buttonHolder) {
        this.collapsible = new Collapsible(this.buttonHolder);
      }

// Bind cart drawer close button event
      this.cartDrawerToggle = this.cartDrawer.querySelector(selectors$E.cartDrawerToggle);
      this.cartDrawerToggle.addEventListener('click', this.cartDrawerToggleClickEvent);

      this.isCartDrawerLoaded = true;

      this.renderPairProducts();

// Hook for cart drawer loaded event
      document.dispatchEvent(new CustomEvent('theme:cart:loaded', {bubbles: true}));

// Open cart drawer after cart items and events are loaded
      if (alwaysOpen) {
        this.openCartDrawer();
      }
    }


/**
     * Open cart dropdown and add class on body
     *
     * @return  {Void}
     */

    openCartDrawer() {
      if (this.isCartDrawerOpen) {
        return;
      }

      if (!this.isCartDrawerLoaded) {
        this.renderCartDrawer();
        return;
      }

// Hook for cart drawer open event
      document.dispatchEvent(new CustomEvent('theme:cart:open', {bubbles: true}));
      document.dispatchEvent(new CustomEvent('theme:scroll:lock', {
        bubbles: true,
        detail: this.cartDrawer
      }));
      document.dispatchEvent(new CustomEvent('theme:scroll:lock', {
        bubbles: true,
        detail: this.cartDrawerBody
      }));

      document.body.classList.add(classes$u.cartDrawerOpen);
      this.cartDrawer.classList.add(classes$u.open);
      this.cartDrawer.classList.remove(classes$u.contentVisibilityHidden);

// Cart elements opening animation
      this.cartDrawer.querySelectorAll(selectors$E.aos).forEach((item) => {
        requestAnimationFrame(() => {
          item.classList.add(classes$u.aosAnimate);
        });
      });

      this.cartToggleButtons.forEach((button) => {
        button.setAttribute(attributes$p.ariaExpanded, true);
      });

      this.a11y.trapFocus({container: this.cartDrawer});

// Observe Additional Checkout Buttons
      this.observeAdditionalCheckoutButtons();
      this.isCartDrawerOpen = true;
    }


/**
     * Close cart dropdown and remove class on body
     *
     * @return  {Void}
     */

    closeCartDrawer() {
      if (!this.isCartDrawerOpen) {
        return;
      }

// Hook for cart drawer close event
      document.dispatchEvent(new CustomEvent('theme:cart:close', {bubbles: true}));

// Cart elements closing animation

      if (this.cartAnimationTimer) {
        clearTimeout(this.cartAnimationTimer);
      }

      this.cartAnimationTimer = setTimeout(() => {
        this.cartDrawer.querySelectorAll(selectors$E.aos).forEach((item) => {
          item.classList.remove(classes$u.aosAnimate);
        });
      }, 300);

      this.cartErrorHolder.classList.remove(classes$u.expanded);

      this.a11y.removeTrapFocus();

      this.cartToggleButtons.forEach((button) => {
        button.setAttribute(attributes$p.ariaExpanded, false);
      });

      document.body.classList.remove(classes$u.cartDrawerOpen);
      this.cartDrawer.classList.remove(classes$u.open);
      this.itemsHolder.classList.remove(classes$u.updated);

      const onCartDrawerTransitionEnd = (event) => {
        if (event.target !== this.cartDrawer) return;
        

        requestAnimationFrame(() => {
          this.cartDrawer.classList.add(classes$u.contentVisibilityHidden);
        });

        this.cartDrawer.removeEventListener('transitionend', onCartDrawerTransitionEnd);
      };

      this.cartDrawer.addEventListener('transitionend', onCartDrawerTransitionEnd);

// Fixes header background update on cart-drawer close
      const isFocusEnabled = !document.body.classList.contains(classes$u.noOutline);
      if (! isFocusEnabled) {
        requestAnimationFrame(() => {
          document.activeElement.blur();
        });
      }

// Enable page scroll right after the closing animation ends
      const timeout = 400;
      document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {
        bubbles: true,
        detail: timeout
      }));

      this.isCartDrawerOpen = false;
    }


/**
     * Toggle cart dropdown
     *
     * @return  {Void}
     */

    toggleCartDrawer() {
      if (this.isCartDrawerOpen) {
        this.closeCartDrawer();
      } else {
        this.openCartDrawer();
      }
    }


/**
     * Cart drawer toggle events
     *
     * @return  {Void}
     */

    cartDrawerToggleEvents() {
      if (!this.cartDrawer) return;
      

// Close cart drawer on ESC key pressed
      this.cartDrawer.addEventListener('keyup', (event) => {
        if (event.code === 27) {
          this.closeCartDrawer();
        }
      });

// Define cart drawer toggle button click event
      this.cartDrawerToggleClickEvent = (event) => {
        event.preventDefault();
        const button = event.target;

        if (button.getAttribute(attributes$p.ariaExpanded) === 'false') {
          this.a11y.state.trigger = button;
        }

        this.toggleCartDrawer();
      };

// Define cart drawer close event
      this.cartDrawerCloseEvent = (event) => {
        const isCartDrawerToggle = event.target.matches(selectors$E.cartDrawerToggle);
        const isCartDrawerChild = document.querySelector(selectors$E.cartDrawer).contains(event.target);
        const isPopupQuickView = event.target.closest(selectors$E.popupQuickView);

        if (! isCartDrawerToggle && ! isCartDrawerChild && ! isPopupQuickView) {
          this.closeCartDrawer();
        }
      };

// Bind cart drawer toggle buttons click event
      this.cartToggleButtons.forEach((button) => {
        button.addEventListener('click', this.cartDrawerToggleClickEvent);
      });

// Close drawers on click outside
// Replaced 'click' with 'mousedown' as a quick and simple fix to the dragging issue on the upsell slider
// which was causing the cart-drawer to close when we start dragging the slider and finish our drag outside the cart-drawer
// which was triggering the 'click' event
      document.addEventListener('mousedown', this.cartDrawerCloseEvent);
    }


/**
     * Toggle classes on different containers and messages
     *
     * @return  {Void}
     */

    toggleClassesOnContainers() {
      const that = this;

      this.emptyMessage.classList.toggle(classes$u.hidden, that.hasItemsInCart());
      this.buttonHolder.classList.toggle(classes$u.hidden, ! that.hasItemsInCart());
      this.itemsHolder.classList.toggle(classes$u.hidden, ! that.hasItemsInCart());
      this.cartItemsQty.classList.toggle(classes$u.hidden, ! that.hasItemsInCart());
    }


/**
     * Build cart depends on results
     *
     * @param   {Object}  data
     *
     * @return  {Void}
     */

    build(data) {
      const cartItemsData = data.querySelector(selectors$E.apiLineItems);
      const upsellItemsData = data.querySelector(selectors$E.apiUpsellItems);
      const cartEmptyData = Boolean(cartItemsData === null && upsellItemsData === null);
      const priceData = data.querySelector(selectors$E.apiCartPrice);
      const cartTotal = data.querySelector(selectors$E.cartTotal);

      if (this.priceHolder && priceData) {
        this.priceHolder.innerHTML = priceData.innerHTML;
      }

// Cart page empty state animations re-init
      this.emptyMessage.querySelectorAll(selectors$E.aos).forEach((item) => {
        item.classList.remove(classes$u.aosAnimate);
      });

      if (cartEmptyData) {
        this.itemsHolder.innerHTML = '';

        if (this.pairProductsHolder) {
          this.pairProductsHolder.innerHTML = '';
        }
      } else {
        this.itemsHolder.innerHTML = cartItemsData.innerHTML;

        if (this.pairProductsHolder) {
          this.pairProductsHolder.innerHTML = upsellItemsData.innerHTML;
        }

        this.renderPairProducts();
      }

      this.newTotalItems = cartItemsData && cartItemsData.querySelectorAll(selectors$E.item).length
        ? cartItemsData.querySelectorAll(selectors$E.item).length
        : 0;
      this.subtotal = cartTotal && cartTotal.hasAttribute(attributes$p.cartTotal)
        ? parseInt(cartTotal.getAttribute(attributes$p.cartTotal))
        : 0;
      this.cartCount = this.getCartItemCount();

      if (this.cartMessage.length > 0) {
        this.updateProgress();
      }

      this.cartToggleButtons.forEach((button) => {
        button.classList.remove(classes$u.cartItems);

        if (this.newTotalItems > 0) {
          button.classList.add(classes$u.cartItems);
        }
      });

      this.toggleErrorMessage();
      this.updateItemsQuantity(this.cartCount);

// Update cart total price
      this.cartTotalPrice.innerHTML = this.subtotal === 0
        ? window.theme.strings.free
        : this.formatMoney(this.subtotal, theme.moneyWithCurrencyFormat);

      if (this.totalItems !== this.newTotalItems) {
        this.totalItems = this.newTotalItems;

        this.toggleClassesOnContainers();
      }

// Add class "is-updated" line items holder to reduce cart items animation delay via CSS variables
      if (this.isCartDrawerOpen) {
        this.itemsHolder.classList.add(classes$u.updated);
      }

      this.cartEvents();
      this.initQuantity();
      this.enableCartButtons();
      this.resetButtonClasses();
      this.removeLoadingClass();

      document.dispatchEvent(new CustomEvent('theme:cart:added', {bubbles: true}));

      if (this.cartDrawer) {
        this.openCartDrawer();
      }
    }


/**
     * Get cart item count
     *
     * @return  {Void}
     */

    getCartItemCount() {

// Returning 0 and not the actual cart items count is done only for when "Cart type" settings are set to "Page"
// The actual count is necessary only when we build and render the cart/cart-drawer after we get a response from the Cart API
      if (!this.cart) return 0;
      
      return Array.from(this.cart.querySelectorAll(selectors$E.qtyInput)).reduce((total, quantityInput) => total + parseInt(quantityInput.value), 0);
    }


/**
     * Check for items in the cart
     *
     * @return  {Void}
     */

    hasItemsInCart() {
      return this.totalItems > 0;
    }


/**
     * Show/hide free shipping message
     *
     * @param   {Number}  total
     *
     * @return  {Void}
     */

    freeShippingMessageHandle(total) {
      if (this.cartMessage.length > 0) {
        document.querySelectorAll(selectors$E.cartMessage).forEach((message) => {
          const hasFreeShipping = message.hasAttribute(attributes$p.cartMessageValue) && message.getAttribute(attributes$p.cartMessageValue) === 'true' && total !== 0;
          const cartMessageDefault = message.querySelector(selectors$E.cartMessageDefault);

          message.classList.toggle(classes$u.success, total >= this.cartFreeLimitShipping && hasFreeShipping);
          message.classList.toggle(classes$u.isHidden, total === 0);
          cartMessageDefault.classList.toggle(classes$u.isHidden, total >= this.cartFreeLimitShipping);
        });
      }
    }


/**
     * Update progress when update cart
     *
     * @return  {Void}
     */

    updateProgress() {
      const newPercentValue = (this.subtotal / this.cartFreeLimitShipping) * 100;
      const leftToSpend = this.formatMoney(this.cartFreeLimitShipping - this.subtotal, theme.money_format)

      if (this.cartMessage.length > 0) {
        document.querySelectorAll(selectors$E.cartMessage).forEach((message) => {
          const cartMessageProgressItems = message.querySelectorAll(selectors$E.cartProgress);
          const leftToSpendMessage = message.querySelector(selectors$E.leftToSpend);

          if (leftToSpendMessage) {
            leftToSpendMessage.innerHTML = leftToSpend.replace('.00', '').replace(',00', '');
          }

          if (cartMessageProgressItems.length) {
            cartMessageProgressItems.forEach((cartMessageProgress, index) => {
              cartMessageProgress.classList.toggle(classes$u.isHidden, this.subtotal / this.cartFreeLimitShipping >= 1);
              cartMessageProgress.style.setProperty('--progress-width', `${newPercentValue}%`);
              if (index === 0) {
                cartMessageProgress.setAttribute(attributes$p.value, newPercentValue);
              }
            });
          }

          this.freeShippingMessageHandle(this.subtotal);
        });
      }
    }


/**
     * Render Upsell Products
     */
    renderPairProducts() {
      this.flktyUpsell = null;
      this.pairProductsHolder = document.querySelector(selectors$E.pairProductsHolder);
      this.pairProducts = document.querySelector(selectors$E.pairProducts);
      this.upsellHolders = document.querySelectorAll(selectors$E.upsellHolder);

      if (this.pairProductsHolder === null || this.pairProductsHolder === undefined) {
        return;
      }

/* Upsell slider
      const that = this;
      if (this.upsellHolders.length > 1) {
        this.flktyUpsell = new Flickity(this.pairProducts, {
          wrapAround: true,
          pageDots: true,
          adaptiveHeight: true,
          prevNextButtons: false,
          on: {
            ready: function() {
              new QuickViewPopup(that.cart);
              this.reloadCells();
              requestAnimationFrame(() => this.resize());
            }
          }
        });

        return;
      } */

// Single upsell item
      new QuickViewPopup(this.cart);
    }

    updateItemsQuantity(itemsQty) {
      let oneItemText = theme.strings.cart_items_one;
      let manyItemsText = theme.strings.cart_items_many;
      oneItemText = oneItemText ?. split('}}')[1];
      manyItemsText = manyItemsText ?. split('}}')[1];

      if (this.cartItemsQty) {
        this.cartItemsQty.textContent = itemsQty === 1
          ? `${itemsQty} ${oneItemText}`
          : `${itemsQty} ${manyItemsText}`;
      }
    }

    observeAdditionalCheckoutButtons() {

// identify an element to observe
      const additionalCheckoutButtons = this.cart.querySelector(selectors$E.additionalCheckoutButtons);
      if (additionalCheckoutButtons) {

// create a new instance of `MutationObserver` named `observer`,
// passing it a callback function
        const observer = new MutationObserver(() => {
          this.a11y.removeTrapFocus();
          this.a11y.trapFocus({container: this.cart});
          observer.disconnect();
        });

// call `observe()` on that MutationObserver instance,
// passing it the element to observe, and the options object
        observer.observe(additionalCheckoutButtons, {
          subtree: true,
          childList: true
        });
      }
    }

    formSubmitHandler() {
      const termsAccepted = document.querySelector(selectors$E.cartTermsCheckbox).checked;
      const termsError = document.querySelector(selectors$E.termsErrorMessage);

// Disable form submit if terms and conditions are not accepted
      if (! termsAccepted) {
        if (document.querySelector(selectors$E.termsErrorMessage).length > 0) {
          return;
        }

        termsError.innerText = theme.strings.cart_acceptance_error;
        this.cartCheckoutButton.setAttribute(attributes$p.disabled, true);
        termsError.classList.add(classes$u.expanded);
      } else {
        termsError.classList.remove(classes$u.expanded);
        this.cartCheckoutButton.removeAttribute(attributes$p.disabled);
      }
    }

    resetButtonClasses() {
      const buttons = document.querySelectorAll(selectors$E.buttonAddToCart);
      if (buttons) {
        buttons.forEach((button) => {
          if (button.classList.contains(classes$u.loading)) {
            button.classList.remove(classes$u.loading);
            button.classList.add(classes$u.success);

            setTimeout(() => {
              button.removeAttribute(attributes$p.disabled);
              button.classList.remove(classes$u.success);
            }, settings$1.timers.addProductTimeout);
          }
        });
      }
    }

    addLoadingClass() {
      if (this.cartDrawer) {
        this.cartDrawer.classList.add(classes$u.loading);
      } else if (this.itemsWrapper) {
        this.itemsWrapper.classList.add(classes$u.loading);
      }
    }

    removeLoadingClass() {
      if (this.cartDrawer) {
        this.cartDrawer.classList.remove(classes$u.loading);
      } else if (this.itemsWrapper) {
        this.itemsWrapper.classList.remove(classes$u.loading);
      }
    }

    formatMoney(value, formatString) {
      const defaultFormat = '${{ amount }}';
      if (typeof value === 'string') {
        value = value.replace(".", "");
      }

      const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
      const format = formatString || defaultFormat;

      function formatValue(value, decimalPlaces = 2, thousandsSeparator = ",", decimalSeparator = ".") {
        value = parseFloat(value);

        if (isNaN(value) || value === null) {
          return "0";
        }

        const fixedValue = (value / 100).toFixed(decimalPlaces);
        const [integerPart, decimalPart] = fixedValue.split(".");

        const formattedIntegerPart = integerPart.replace(/(\d)(?=(\d{3})+(?!\d))/g, `$1${thousandsSeparator}`);
        const formattedValue = decimalPart
          ? formattedIntegerPart + decimalSeparator + decimalPart
          : formattedIntegerPart;

        return formattedValue;
      }

      const match = format.match(placeholderRegex);
      if (! match) return"Invalid format string";
      
      const placeholder = match[1];

      let formattedValue = "";
      switch (placeholder) {
        case "amount": formattedValue = formatValue(value, 2);
          break;
        case "amount_no_decimals": formattedValue = formatValue(value, 0);
          break;
        case "amount_with_comma_separator": formattedValue = formatValue(value, 2, ".", ",");
          break;
        case "amount_no_decimals_with_comma_separator": formattedValue = formatValue(value, 0, ".", ",");
          break;
      }

      return format.replace(placeholderRegex, formattedValue);
    }

  }

  class Collapsible {
    constructor(container) {
      this.container = container;
      this.single = this.container.querySelector(selectors$11.single);
      this.triggers = this.container.querySelectorAll(selectors$11.trigger);
      this.resetHeightTimer = 0;
      this.isTransitioning = false;
      this.transitionOverride = this.container.hasAttribute(attributes$G.transitionOverride);
      this.collapsibleToggleEvent = (event) => throttle(this.collapsibleToggle(event), 1250);

      this.init();
    }

    init() {
      this.triggers.forEach((trigger) => {
        trigger.addEventListener('click', this.collapsibleToggleEvent);
        trigger.addEventListener('keyup', this.collapsibleToggleEvent);
      });
    }

    collapsibleToggle(e) {
        e.preventDefault();

        const trigger = e.target.matches(selectors$11.trigger)
          ? e.target
          : e.target.closest(selectors$11.trigger);
        const dropdownId = trigger.getAttribute(attributes$G.controls);
        const dropdown = document.getElementById(dropdownId);
        const triggerMobile = trigger.hasAttribute(attributes$G.triggerMobile);
        const isExpanded = trigger.classList.contains(classes$Q.isExpanded);
        const isSpace = e.code === 32;
        const isEscape = e.code === 27;
        const isMobile = window.innerWidth<theme.viewport.isXs();

      // Do nothing if transitioning
      if (this.isTransitioning && !this.transitionOverride) {
        return;
      }

      // Do nothing if any different than ESC and Space key pressed
      if (e.code && !isSpace && !isEscape) {
        return;
      }

      // Do nothing if ESC key pressed and not expanded or mobile trigger clicked and screen not mobile
      if ((!isExpanded && isEscape) || (triggerMobile && !isMobile)) {
        return;
      }

      this.isTransitioning = true;
      trigger.disabled = true;

      // When we want only one item expanded at the same time
      if (this.single) {
        this.triggers.forEach((otherTrigger) => {
          const isExpanded = otherTrigger.classList.contains(classes$Q.isExpanded);

          if (trigger == otherTrigger || ! isExpanded) return;
          

          const dropdownId = otherTrigger.getAttribute(attributes$G.controls);
          const dropdown = document.getElementById(dropdownId);

          requestAnimationFrame(() => {
            this.closeItem(dropdown, otherTrigger);
          });
        }
      );
    }

// requestAnimationFrame fixes content jumping when item is sliding down
    if (isExpanded) {
      requestAnimationFrame(() => {
        this.closeItem(dropdown, trigger);
      });
    } else {
      requestAnimationFrame(() => {
        this.openItem(dropdown, trigger);
      });
    }
  }

  openItem(dropdown, trigger) {
    let dropdownHeight = dropdown.querySelector(selectors$11.content).offsetHeight;

    this.setDropdownHeight(dropdown, dropdownHeight, trigger, true);
    trigger.classList.add(classes$Q.isExpanded);
    trigger.setAttribute(attributes$G.expanded, true);

    trigger.dispatchEvent(new CustomEvent('theme:form:sticky', {
      bubbles: true,
      detail: {
        element: 'accordion'
      }
    }));
  }

  closeItem(dropdown, trigger) {
    let dropdownHeight = dropdown.querySelector(selectors$11.content).offsetHeight;

    requestAnimationFrame(() => {
      dropdownHeight = 0;
      this.setDropdownHeight(dropdown, dropdownHeight, trigger, false);
      trigger.classList.remove(classes$Q.isExpanded);
    });

    this.setDropdownHeight(dropdown, dropdownHeight, trigger, false);
    trigger.classList.remove(classes$Q.isExpanded);
    trigger.setAttribute(attributes$G.expanded, false);
  }

  setDropdownHeight(dropdown, dropdownHeight, trigger, isExpanded) {
    dropdown.style.height = `${dropdownHeight}px`;
    dropdown.setAttribute(attributes$G.expanded, isExpanded);
    dropdown.classList.toggle(classes$Q.isExpanded, isExpanded);

    if (this.resetHeightTimer) {
      clearTimeout(this.resetHeightTimer);
    }

    if (dropdownHeight == 0) {
      this.resetHeightTimer = setTimeout(() => {
        dropdown.style.height = '';
      }, settings$6.animationDelay);
    }

    if (isExpanded) {
      this.resetHeightTimer = setTimeout(() => {
        dropdown.style.height = 'auto';
        this.isTransitioning = false;
      }, settings$6.animationDelay);
    } else {
      this.isTransitioning = false;
    }

// Always remove trigger disabled attribute after animation completes
    setTimeout(() => {
      trigger.disabled = false;
    }, settings$6.animationDelay);
  }

  onUnload() {
    this.triggers.forEach((trigger) => {
      trigger.removeEventListener('click', this.collapsibleToggleEvent);
      trigger.removeEventListener('keyup', this.collapsibleToggleEvent);
    });
  }
}

class QuickViewPopup {
  constructor(container) {
    this.container = container;
    this.a11y = a11y;
    this.buttonsQuickView = this.container.querySelectorAll(selectors$F.buttonQuickView);
    this.buttonsShopTheLookQuickView = this.container.querySelectorAll(selectors$F.shopTheLookQuickViewButton);
    this.popupInitCallback = (trigger) => this.popupInit(trigger);

    this.buttonsQuickView ?. forEach((button) => {
      if (!button.hasAttribute(attributes$q.quickButtonInit)) {
        button.addEventListener('click', (event) => this.initPhotoswipe(event));
        button.addEventListener('theme:popup:init', () => {
          button.classList.remove(classes$v.loading);

          if (button.hasAttribute(attributes$q.shopTheLookQuickView)) {
            this.popupInitCallback(button);
          }
        });
        button.setAttribute(attributes$q.quickButtonInit, '');
      }
    });

    this.buttonsShopTheLookQuickView ?. forEach((button) => {
      button.addEventListener('click', () => {
        this.buttonsQuickView[0] ?. dispatchEvent(new Event('click'));
      });
    });
  }

  popupInit(trigger) {

// Handle active Quick View item
    const holder = this.loadPhotoswipe.pswpElement.querySelector(`[${
      attributes$q.hotspot
    }="${
      trigger.getAttribute(attributes$q.hotspot)
    }"]`);
    const quickViewItemHolders = this.loadPhotoswipe.pswpElement.querySelectorAll(selectors$F.quickViewItemHolder);

    holder.classList.add(classes$v.isActive);

    quickViewItemHolders.forEach((element) => {
      if (element !== holder) {
        element.classList.remove(classes$v.isActive);
      }
    });

// Handle pointer events
    this.toggleQuickViewButtonsLoadingClasses(true);
    this.toggleQuickViewThumbsLoadingClasses(true);

    const onAnimationInEnd = (event) => {

// Animation on open
      if (event.animationName === 'quickViewAnimateInUp') {
        requestAnimationFrame(() => {
          this.toggleQuickViewThumbsLoadingClasses(false);
        });
      }

// Animation on close
      if (event.animationName === 'quickViewAnimateOutDown') {
        this.loadPhotoswipe.pswpElement.removeEventListener('animationend', onAnimationInEnd);
      }
    };

    this.loadPhotoswipe.pswpElement.addEventListener('animationend', onAnimationInEnd);

    this.loadPhotoswipe ?. popup ?. listen('destroy', () => {
      this.toggleQuickViewButtonsLoadingClasses(false);
      this.toggleQuickViewThumbsLoadingClasses(false);
    });
  }

  toggleQuickViewButtonsLoadingClasses(isLoading = true) {
    if (isLoading) {
      this.buttonsQuickView ?. forEach((element) => {
        element.classList.add(classes$v.loading);
      });
      return;
    }

    this.buttonsQuickView ?. forEach((element) => {
      element.classList.remove(classes$v.loading);
    });
  }

  toggleQuickViewThumbsLoadingClasses(isLoading = true) {
    this.buttonsShopTheLookThumb = this.loadPhotoswipe ?. pswpElement.querySelectorAll(selectors$F.shopTheLookThumb);

    if (isLoading) {
      this.buttonsShopTheLookThumb ?. forEach((element) => {
        element.classList.add(classes$v.loading);
      });
      return;
    }

    this.buttonsShopTheLookThumb ?. forEach((element) => {
      element.classList.remove(classes$v.loading);
    });
  }

  initPhotoswipe(event) {
      event.preventDefault();

      const button = event.target.matches(selectors$F.buttonQuickView)
        ? event.target
        : event.target.closest(selectors$F.buttonQuickView);
      const isMobile = window.innerWidth<theme.sizes.small;
    let quickViewVariant = '';
    let isShopTheLookPopupTrigger = false;

    if (button.hasAttribute(attributes$q.shopTheLookQuickView)) {
    if (!isMobile) return;
    isShopTheLookPopupTrigger = true;
    }

    options.mainClass = classes$v.mainClass;
    button.classList.add(classes$v.loading);

    // Add class js-quick-view-from-cart to change the default Quick view animation
    if (button.closest(selectors$F.cartDrawer)) {
    document.body.classList.add(classes$v.quickViewFromCart);
    }

    // Set the trigger element before calling trapFocus
    this.a11y.state.trigger = button;

    if (button.hasAttribute(attributes$q.variantId)) {
    quickViewVariant = `&variant=${button.getAttribute(attributes$q.variantId)}`;
    }

    const productUrl = `${theme.routes.root}products/${button.getAttribute(attributes$q.handle)}?section_id=api-quickview${quickViewVariant}`;

    if (isShopTheLookPopupTrigger) {
    options.mainClass = classes$v.shopTheLookPopupClass;

    this.buttonsQuickView.forEach((element) => {
        element.classList.add(classes$v.loading);
      }
    );

    const XMLS = new XMLSerializer();
    const quickViewItemsTemplate = this
      .container
      .querySelector(selectors$F.quickViewItemsTemplate)
      .content
      .firstElementChild
      .cloneNode(true);

    const itemsData = XMLS.serializeToString(quickViewItemsTemplate);

    this.loadPhotoswipeWithTemplate(itemsData, button);
  } else {
    this.loadPhotoswipeFromFetch(productUrl, button);
  }
}

loadPhotoswipeWithTemplate(data, button) {
  const items = [{
      html: data
    }];

  this.loadPhotoswipe = new LoadPhotoswipe(items, options, settings$2.templateIndex, button);
}

loadPhotoswipeFromFetch(url, button) {
  fetch(url).then((response) => {
    return response.text();
  }).then((data) => {
    const items = [{
        html: data
      }];

    this.loadPhotoswipe = new LoadPhotoswipe(items, options, settings$2.templateIndex, button);
  }).catch((error) => console.log(error));
}}class QuantityCounter {
constructor(holder, inCart = false) {
  this.holder = holder;
  this.quantityUpdateCart = inCart;
}

init() {

// DOM Elements
  this.quantity = this.holder.querySelector(selectors$10.quantityHolder);

  if (!this.quantity) {
    return;
  }

  this.field = this.quantity.querySelector(selectors$10.quantityField);
  this.buttons = this.quantity.querySelectorAll(selectors$10.quantityButton);
  this.increaseButton = this.quantity.querySelector(selectors$10.quantityPlusButton);

// Set value or classes
  this.quantityValue = Number(this.field.value || 0);
  this.cartItemID = this.field.getAttribute('data-id');
  this.maxValue = Number(this.field.getAttribute('max')) > 0
    ? Number(this.field.getAttribute('max'))
    : null;
  this.minValue = Number(this.field.getAttribute('min')) > 0
    ? Number(this.field.getAttribute('min'))
    : 0;
  this.disableIncrease = this.disableIncrease.bind(this);

// Flags
  this.emptyField = false;

// Methods
  this.updateQuantity = this.updateQuantity.bind(this);
  this.decrease = this.decrease.bind(this);
  this.increase = this.increase.bind(this);

  this.disableIncrease();

// Events
  if (!this.quantity.classList.contains(classes$P.quantityReadOnly)) {
    this.changeValueOnClick();
    this.changeValueOnInput();
  }
}


/**
     * Change field value when click on quantity buttons
     *
     * @return  {Void}
     */

changeValueOnClick() {
  this.buttons.forEach((element) => {
    element.addEventListener('click', (event) => {
      event.preventDefault();

      this.quantityValue = Number(this.field.value || 0);

      const clickedElement = event.target;
      const isDescrease = clickedElement.matches(selectors$10.quantityMinusButton) || clickedElement.closest(selectors$10.quantityMinusButton);
      const isIncrease = clickedElement.matches(selectors$10.quantityPlusButton) || clickedElement.closest(selectors$10.quantityPlusButton);

      if (isDescrease) {
        this.decrease();
      }

      if (isIncrease) {
        this.increase();
      }

      this.updateQuantity();
    });
  });
}


/**
     * Change field value when input new value in a field
     *
     * @return  {Void}
     */

changeValueOnInput() {
  this.field.addEventListener('input', () => {
    this.quantityValue = this.field.value;
    this.updateQuantity();
  });
}


/**
     * Update field value
     *
     * @return  {Void}
     */

updateQuantity() {
  if (this.maxValue<this.quantityValue && this.maxValue !== null) {
        this.quantityValue = this.maxValue;
      }

      if (this.minValue> this.quantityValue) {
    this.quantityValue = this.minValue;
  }

  this.field.value = this.quantityValue;

  this.disableIncrease();

  // document.dispatchEvent(new CustomEvent('theme:cart:update'));

  if (this.quantityUpdateCart) {
    this.updateCart();
  }
}


/**
     * Decrease value
     *
     * @return  {Void}
     */

decrease() {
  if (this.quantityValue > this.minValue) {
    this.quantityValue --;

    return;
  }

  this.quantityValue = 0;
}


/**
     * Increase value
     *
     * @return  {Void}
     */

increase() {
  this.quantityValue ++;
}


/**
     * Disable increase
     *
     * @return  {[type]}  [return description]
     */

disableIncrease() {
  this.increaseButton.classList.toggle(classes$P.isDisabled, this.quantityValue >= this.maxValue && this.maxValue !== null);
}

updateCart() {
  if (this.quantityValue === '') return;
  

  const event = new CustomEvent('theme:cart:update', {
    bubbles: true,
    detail: {
      id: this.cartItemID,
      quantity: this.quantityValue
    }
  });

  this.holder.dispatchEvent(event);
}}_cartDrawer = new CartDrawer();window.addEventListener('theme:scroll:lock', lock);window.addEventListener('theme:scroll:unlock', unlock);});